import axios from '@/js/lib/axios';
import { updateToken } from '@/js/lib/api/update_token';

export const signup = async ({ email, password, shopName }: { email: string; password: string; shopName: string }): Promise<''> => {
  const token = await updateToken();

  const res = await axios.post('/api/signup/shop', {
    shop_name: shopName,
    email,
    password,
    token,
  });

  return res.data;
};
